import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { withStyles, Radio, TextField, Typography } from '@material-ui/core';
import ReactSelect from './../../../../common/components/UI/Select/ReactSelect';
import LocationsPicker from '../../LocationsPicker';
import cloneDeep from 'lodash/cloneDeep';
import { getParsedLocations } from '../../Services/location.service';
import moment from 'moment';
import ActionButtons from './../../../../common/components/UI/ActionButtons/ActionButtons';
import InputNumber from './../../../../common/components/UI/Input/Number';
import axios from 'axios';
import { workPlanForm } from '../../../styles/workplanStyles';
import { updateMAINworkPlans, updateSpinnerShow, updateSelectedWorkPlan } from '../actions';
import { connect } from 'react-redux';
import { exists, currentHttpOptions } from '../../../../common/utilities/utilitiesFunctions';

const styles = theme => (workPlanForm(theme));

const CssTextField = withStyles({
    root: {
        marginTop: '50px',
        fontSize: '14px',
        '& label': {
            color: '#878787',
            marginTop: '-20px'
        },
        '& label.MuiInputLabel-outlined.MuiInputLabel-shrink': {
            transform: 'translate(0px, -2px) scale(0.75)'
        },
        '& label.Mui-focused': {
            color: '#878787',
            marginTop: '-20px'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        },
        '& .MuiOutlinedInput-multiline': {
            padding: 0
        },
        '& .Mui-error': {
            color: '#red'
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#E6EDF5',
                '& legend': {
                    display: 'none'
                },
            },
            '&:hover fieldset': {
                borderColor: '#878787',
                borderWidth: '1px'
            },
            '&.Mui-focused fieldset': {
                borderColor: '#878787',
                borderWidth: '1px'
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: '10px 12px',
            fontSize: '14px',
            color: '#656565',
            marginTop: '-4px',
            backgroundColor: 'white'
        }
    }
})(TextField);

class WorkPlanForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showButtons: false,
            WPName: '',
            status: '',
            locationNodes: {},
            workplanLocations: [],
            WPDescription: '',
            WPJob: '',
            WPDurationType: "Weeks",
            WPDuration: 1,
            editMode: false,
            errorName: false,
            currentLocation: [],
            showModal: false,
            visible: false,
            location: [],
            locationsSelected: [],
            spinnerShow: false,
            INITWPDescription: '',
            INITWPName: '',
            adminSetting: '',
            errorField: false,
            notSubmitable: true
        };
    }

    componentDidMount = async () => {
        const { selectedWorkPlan, settingsList, action } = this.props;
        let locations;
        if (selectedWorkPlan !== '') {
            let isCopy = action === 'DuplicateWorkplan';
            let name = isCopy ? `Copy of ${selectedWorkPlan.name}_${moment().format('YYYY-MM-DDThh:mm:ss')}` : selectedWorkPlan.name;

            let orgPaths = selectedWorkPlan.jobs.map(job => job.orgPath);
            let listSelectedLocations = selectedWorkPlan.jobs.map(job => job.nodeId);

            let auxCurrentLocation = [], auxLocations = [];

            locations = await getParsedLocations(moment.utc().format('YYYY-MM-DD'))

            auxLocations = locations;
            for (const key in auxLocations) {
                if (listSelectedLocations.includes(auxLocations[key].nodeId)) {
                    auxCurrentLocation.push(cloneDeep(auxLocations[key]));
                }
            }
            let locationsSelected = auxCurrentLocation.map(location => location.path)

            this.setState({
                locationsSelected: locationsSelected,
                locationNodes: locations,
                orgPaths: orgPaths,
                workplanLocations: listSelectedLocations,
                currentTree: locations.data,
                isCopy,
                WPName: name,
                INITWPName: name,
                status: selectedWorkPlan.statusLabel,
                WPDescription: selectedWorkPlan.description,
                INITWPDescription: selectedWorkPlan.description,
                WPDurationType: selectedWorkPlan.periodType,
                WPDuration: selectedWorkPlan.periodLength,
                adminSetting: selectedWorkPlan !== '' ? settingsList.find(setting => setting.id === selectedWorkPlan.adminSettingId) : ''
            })
        }
        else {
            locations = await getParsedLocations(moment.utc().format('YYYY-MM-DD'))
            this.setState({
                locationNodes: locations,
            })
        }


    }

    handleChangeInput = (target, value) => {
        if (target === 'WPName') {
            this.setState({
                [target]: value,
                errorName: false,
            }, () => this.setState({ submitableForm: this.submitableForm() }))
        } else {
            this.setState({ [target]: value }, () => this.setState({ submitableForm: this.submitableForm() }))
        }
    }

    handleRadioChange = (event) => {
        this.setState({
            WPDuration: 1,
            WPDurationType: event.target.value
        })
    }

    submitForm = async () => {
        const { updateMAINworkPlans, updateSpinnerShow, action, selectedWorkPlan, closeForm } = this.props;
        const { workplanLocations, WPName, WPDescription, WPDurationType, WPDuration, adminSetting, notSubmitable, isCopy, locationNodes } = this.state;

        if (!notSubmitable || isCopy) {
            if (this.uniqueName()) {
                updateSpinnerShow(true);
                let jobs = [];
                
                if(action === 'CreateWorkplan' ){
                    for (const workplanLocation of workplanLocations) {
                        var locationInformation = locationNodes[workplanLocation];
                        if( locationInformation ){
                            jobs.push({ nodeId: locationInformation.nodeId, orgPath: locationInformation.orgPath, parentNodeId: locationInformation.parentNodeId });
                        }
                    }
                }
                

                let newWorkplan = {
                    WorkplanId: selectedWorkPlan.workplanId,
                    Name: WPName,
                    Description: WPDescription,
                    Jobs: action === 'CreateWorkplan' ? jobs : selectedWorkPlan.jobs,
                    PeriodType: WPDurationType === "Weeks" ? 2 : 1,
                    PeriodLength: WPDuration,
                    Note: '',
                    AdminSettingsId: adminSetting.value
                }

                await axios.post(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/Workplan/' + action, newWorkplan, currentHttpOptions());
                let newWorkplansList = await axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/Workplan/GetWorkplans', currentHttpOptions());

                updateMAINworkPlans(newWorkplansList.data);
                // await updateSelectedWorkPlan('');
                closeForm();
            } else {
                this.setState({
                    errorName: true,
                    showErroDialog: true
                })
            }
        }
    }

    updating = (currentID) => {
        if (this.props.action === 'EditWorkplan' && (this.props.selectedWorkPlan.workplanId === currentID)) {
            return false
        }
        return true
    }

    uniqueName = () => {
        const { MAINworkPlans } = this.props;
        for (const workplan of MAINworkPlans) {
            if (workplan.name === this.state.WPName && this.updating(workplan.workplanId)) {
                return false
            }
        }

        return true;
    }

    isEditingDuplicating = () => {
        return this.props.action === 'DuplicateWorkplan' || this.props.action === 'EditWorkplan'
    }

    submitableForm = () => {
        const { workplanLocations, WPDuration, errorName, WPName, INITWPName, INITWPDescription, WPDescription, adminSetting } = this.state;
        let notSubmitable = false;

        if (this.props.action === 'EditWorkplan') {
            notSubmitable = INITWPName.trim() === WPName.trim() && INITWPDescription === WPDescription;
        } else {
            notSubmitable = errorName || WPDuration === '' || WPDuration === '0' || workplanLocations.length === 0 || WPName.trim() === '' || adminSetting === '';
        }

        this.setState({ notSubmitable });
    }

    valueHelper = (value, WPDurationType) => {
        if (value === '' || value >= 1) {
            if ((value <= 365 && WPDurationType === "Days") || (value <= 52 && WPDurationType === "Weeks")) {
                return parseInt(value)
            }
        }
        return '';
    }

    showModal = () => {
        if (!this.props.action !== 'EditWorkplan') {
            this.setState({ visible: true })
        }
    }

    selectedNodeHandler = (TEMPcurrentTree, TEMPcurrentLocation) => {
        this.setState({
            TEMPcurrentTree,
            TEMPcurrentLocation
        })
    }

    spinnerState = spinnerShow => {
        this.setState({
            spinnerShow
        })
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    formatPath = (path, number) => {
        if (path) {
            let locationSplit = path.split('/')
            let locationShort = path
            if (locationSplit.length > number) {
                let auxIterator = 0;
                locationShort = ''
                for (let i = locationSplit.length - 1; i >= 0 && auxIterator < number; i--) {
                    locationShort = '/' + locationSplit[i] + locationShort
                    auxIterator++
                }
                locationShort = locationSplit.length > auxIterator ? '...' + locationShort : locationShort
            }
            return locationShort;
        }
        return '';
    }

    Disclaimer = ({ children, ...others }) => (
        <p {...others}>
            <small className="core--disclaimer">
                {children}
            </small>
        </p>
    );
    render() {
        const { classes, t, action, updateSelectedWorkPlan, settingsList, closeForm } = this.props;
        const { WPName, isCopy, WPDescription, WPDurationType, WPDuration, errorName, adminSetting, notSubmitable, locationNodes, workplanLocations } = this.state;
        let modal = '';

        let isEditingDuplicating = this.isEditingDuplicating();

        return (
            <div className={classes.formContainer}>
                <CssTextField
                    label={t('workPlanList.form.name')}
                    onChange={(event) => this.handleChangeInput('WPName', event.target.value)}
                    error={WPName.trim() === '' || errorName}
                    helperText={errorName ? 'Existing name, please change it.' : ''}
                    defaultValue=""
                    value={WPName}
                    fullWidth
                    variant="outlined"
                    inputProps={{ maxLength: 50 }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <this.Disclaimer children={t('workPlanList.form.50maxChar')} />
                <CssTextField
                    label={t('workPlanList.form.description')}
                    onChange={(event) => this.handleChangeInput('WPDescription', event.target.value)}
                    multiline
                    value={WPDescription}
                    rows="4"
                    fullWidth
                    variant="outlined"
                    inputProps={{ maxLength: 50 }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <this.Disclaimer children={t('workPlanList.form.50maxChar')} />
                <div style={{ marginTop: 25, marginBottom: 25 }}>
                    <Typography className={classes.dateTypo}>
                        {isEditingDuplicating ? 'Selected Workplan setup' : 'Select a Workplan setup'}
                    </Typography>
                    {isEditingDuplicating
                        ? <div style={{ paddingLeft: 15 }}>
                            {adminSetting.name + (adminSetting.description !== null && adminSetting.description !== "" ? `(${adminSetting.description})` : '')}
                        </div>
                        : <ReactSelect
                            placeholder={'Select a Workplan setup'}
                            value={adminSetting}
                            options={settingsList.filter(x => x.hasCreateAccess === true)}
                            onChange={(event, value) => this.setState({ adminSetting: value }, () => this.setState({ submitableForm: this.submitableForm() }))}
                            className={classes.selectShiftLineEdit}
                            isDisabled={action === 'EditWorkplan'}
                            error={adminSetting === '' || exists(adminSetting) === false}
                        />}
                </div>

                {<LocationsPicker
                    period={moment().format("yyyy-MM-DD")}
                    locationNodes={locationNodes}
                    selectedNodeIds={workplanLocations}
                    onConfirm={(values) => this.setState({ workplanLocations: values }, () => this.submitableForm())}
                    t={t}
                    disabled={action === 'EditWorkplan' || action === 'DuplicateWorkplan'}
                />}

                <div className={classes.numberContainer}>
                    <div className={classes.label}>
                        {t('workPlanList.form.numberOf')}
                    </div>
                    <div className={classes.radioContainer} style={{ display: 'flex' }}>
                        <Radio style={{ color: isEditingDuplicating ? '#dedede' : '#0A54A2' }}
                            disabled={isEditingDuplicating}
                            checked={WPDurationType === 'Days'}
                            onChange={this.handleRadioChange}
                            value="Days"
                        /><span style={{ paddingTop: 10 }}>Days</span>
                        <Radio style={{ color: isEditingDuplicating ? '#dedede' : '#0A54A2' }}
                            disabled={isEditingDuplicating}
                            checked={WPDurationType === 'Weeks'}
                            onChange={this.handleRadioChange}
                            value="Weeks"
                        /><span style={{ paddingTop: 10 }}>Weeks</span>
                    </div>

                    <InputNumber
                        min={1}
                        isDisabled={isEditingDuplicating}
                        disabled={isEditingDuplicating}
                        max={365}
                        step={1}
                        precision={0}
                        value={WPDuration}
                        strict={true}
                        label={''}
                        target='WPDuration'
                        className={classes.inputNumber}
                        handleChangeInput={(event) => this.handleChangeInput('WPDuration', this.valueHelper(event, WPDurationType))}
                    />

                </div>
                <ActionButtons
                    cancel={() => { updateSelectedWorkPlan(''); closeForm() }}
                    submit={this.submitForm}
                    disabledSubmit={isCopy ? !this.uniqueName() : notSubmitable}
                    color="primary"
                    size="medium"
                    submitText={isCopy ? t('workPlanList.form.duplicate') : 'OK'}
                />
                {modal}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        httpOptions: state.httpOptions,
        selectedWorkPlan: state.selectedWorkPlan,
        MAINworkPlans: state.MAINworkPlans,
        settingsList: state.settingsList,
    }
}

const mapDispatchToProps = {
    updateMAINworkPlans,
    updateSpinnerShow,
    updateSelectedWorkPlan,
}

export default connect(mapStateToProps, mapDispatchToProps)(translate('workplanManager')(withStyles(styles)(WorkPlanForm)));